import styled from 'styled-components';
import { 
  LoadingSpinner 
} from '../../../components/common/StyledComponents';
import BrandLogo from '../../../components/common/BrandLogo';
import {
  AuthContainer,
  AuthCard,
  LogoSection,
  AuthSubtitle,
  FormSection,
  StyledTextField,
  PasswordField,
  ButtonSection,
  ModernButton,
  Alert,
  ToggleSection,
  ToggleButton,
  PasswordToggle,
} from '../../../components/common/AuthLayout';
import { useLoginForm } from '../../../hooks/auth/useAuthForm';

const Login = () => {
  const {
    formData,
    showPassword,
    validationErrors,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    handleGoogleLogin,
    handleKeyPress,
    goToRegister,
    togglePasswordVisibility
  } = useLoginForm();

  return (
    <AuthContainer>
      <AuthCard>
        <LogoSection>
          <BrandLogo height={32} />
          <AuthSubtitle>강의와 첨삭을 이어서 보세요</AuthSubtitle>
        </LogoSection>

        <FormSection onSubmit={handleSubmit}>
          <StyledTextField error={!!validationErrors.id}>
            <label>이메일</label>
            <input
              type="email"
              autoComplete="username"
              value={formData.id}
              onChange={handleInputChange('id')}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="가입 시 사용한 이메일"
            />
            {validationErrors.id && (
              <div className="error-message">{validationErrors.id}</div>
            )}
          </StyledTextField>
          
          <PasswordField error={!!validationErrors.password}>
            <label>비밀번호</label>
            <input
              type={showPassword ? 'text' : 'password'}
              value={formData.password}
              onChange={handleInputChange('password')}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="비밀번호를 입력하세요"
            />
            <PasswordToggle
              visible={showPassword}
              onClick={togglePasswordVisibility}
              disabled={loading}
            />
            {validationErrors.password && (
              <div className="error-message">{validationErrors.password}</div>
            )}
          </PasswordField>

          {error && (
            <Alert severity="error">
              {error}
            </Alert>
          )}

          <ButtonSection>
            <ModernButton
              type="submit"
              variant="primary"
              disabled={loading}
            >
              {loading ? <LoadingSpinner /> : '로그인'}
            </ModernButton>
          </ButtonSection>

          <Divider>
            <span>또는</span>
          </Divider>

          <ButtonSection>
            <GoogleButton
              type="button"
              variant="secondary"
              onClick={handleGoogleLogin}
              disabled={loading}
            >
              <GoogleIcon />
              Google로 로그인
            </GoogleButton>
          </ButtonSection>
        </FormSection>

        <ToggleSection>
          <ToggleButton type="button" onClick={goToRegister}>
            계정이 없으신가요?<strong>회원가입</strong>
          </ToggleButton>
        </ToggleSection>
      </AuthCard>
    </AuthContainer>
  );
};

const GoogleButton = styled(ModernButton)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 4px 0 16px;
  color: #6f6a5c;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.02em;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e7e1d3;
  }
  span {
    padding: 0 12px;
  }
`;

const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" style={{ marginRight: 10 }} aria-hidden="true">
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
    />
  </svg>
);

export default Login;